import { render, staticRenderFns } from "./RegionPicker.vue?vue&type=template&id=85730c80&"
import script from "./RegionPicker.controller.js?vue&type=script&lang=js&"
export * from "./RegionPicker.controller.js?vue&type=script&lang=js&"
import style0 from "./RegionPicker.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports